/* eslint-disable import/exports-last */
import getPublicUrl from '@/helpers/utils/routing/getPublicUrl'
import { type LayoutProps, PageProps } from '@/types'
import { toPathFactory } from '@/helpers/utils/routing/toPathFactories'

export const pageUrl = '/[locale]/fundraising-events/[slug]/manage/live-widgets/voting/[...votingParams]'
export const VotingPageKeys = {
  Draft: 'draft',
  Display: 'display',
  Finished: 'finished',
  Data: 'data',
} as const
export type VotingPageKeys = (typeof VotingPageKeys)[keyof typeof VotingPageKeys]
export type VotingParams = [typeof VotingPageKeys.Draft, string] | [VotingPageKeys] | undefined
type ParamsTypeMap = { '...votingParams': VotingParams }
export const getPageUrl = toPathFactory<typeof pageUrl, ParamsTypeMap>(pageUrl, getPublicUrl)
export type FundraisingEventVotingPageProps = PageProps<
  typeof pageUrl,
  Record<string, string | string[] | undefined>,
  ParamsTypeMap
>
export type FundraisingEventVotingLayoutProps = LayoutProps<
  typeof pageUrl,
  'draft' | 'display' | 'finished' | 'preview',
  ParamsTypeMap
>
